import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const browseActivitiesByInterestsStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: { xs: '50px', md: '72px' },
		pt: { xs: '60px', md: '100px', lg: '80px' },
		pb: { xs: '30px', md: '50px', lg: '80px' },
		px: { xs: '30px', lg: '60px' },
	},
	title: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '20px', md: '30px', lg: '40px' },
		fontStyle: 'italic',
		color: '#120E0D',
		fontWeight: 400,
		textTransform: 'uppercase',
		textAlign: 'left',
	},
	subtitle: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '16px', md: '20px', lg: '24px' },
		lineHeight: '1.25',
		color: Colors['6D7275'],
	},
	buttonSection: { display: 'flex', flexFlow: 'column nowrap', gap: '24px' },
});
